export default __webpack_public_path__ + "static/media/misc-closetC-768w.82f11079.avif";